import { render, staticRenderFns } from "./element.vue?vue&type=template&id=976506c0&scoped=true"
import script from "./element.vue?vue&type=script&lang=js"
export * from "./element.vue?vue&type=script&lang=js"
import style0 from "./element.vue?vue&type=style&index=0&id=976506c0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976506c0",
  null
  
)

export default component.exports